<div>
	<div class="text-center text-tertiary fw-semibold w-100">
		Variável meteorológica por estação - {{ labelVariavel }}
		{{ labelUnidadeVariavel }} -
		{{ labelPeriodo }}
	</div>
	<seira-card-info aditionalClasses="my-3" [texto]="descricaoRelatorio" />
	<div
		*ngIf="isCarregando"
		class="d-flex justify-content-center align-items-center w-100 h-50"
		style="min-height: 500px">
		<seira-loading [pageCentered]="false"></seira-loading>
	</div>
	<div [hidden]="isCarregando || medicoes.length === 0" class="col-12 p-9">
		<div class="col-12 mb-3 mb-lg-0 p-0">
			<div class="p-0 mx-1 w-100">
				<div id="container-mapa" class="flex-grow-1 position-relative">
					<seira-mapa-paraiba-leaflet
						(mapaEmitter)="setupMap($event)"
						[loading]="isCarregando"
						[custonsLayers]="true"
						[monitoramentoMapa]="mapa"
						class="w-100 h-100 position-absolute">
					</seira-mapa-paraiba-leaflet>
				</div>
			</div>
		</div>
	</div>

	<div
		*ngIf="!isCarregando && medicoes.length === 0"
		class="d-flex justify-content-center align-items-center">
		<div
			class="py-2 px-3 my-2 me-2 bg-white d-inline-flex flex-row align-items-center rounded shadow-lg card text-tertiary fw-light">
			Não existem dados a serem exibidos.
		</div>
	</div>
</div>
